import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { DespesaService } from 'administrativo-lib';
import { ProdutoService, ProdutoUnidadeService } from 'almoxarifado-lib';
import { BaseResourceFormComponent, DateFormatPipe, Despesa, EddyAutoComplete, ExercicioService, FuncaoService, GlobalService, LoginContabil, PlanoContratacaoAnual, PlanoContratacaoItem, Produto, ProdutoUnidade, Unidade, UnidadeService } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { CompraItemService } from '../../compra/service/compra-item.service';
import { PlanoContratacaoAnualItensService } from '../service/plano-contratacao-anual-itens.service';
import { PlanoContratacaoAnualService } from '../service/plano-contratacao-anual.service';
import { Alignment, Workbook, Worksheet } from 'exceljs';

declare var $: any;

interface FiltroSituacao {
  val: 'todos' | 'revisados' | 'pendentes';
  label: string;
}

@Component({
  selector: 'lib-plano-contratacao-anual-form',
  templateUrl: './plano-contratacao-anual-form.component.html'
})
export class PlanoContratacaoAnualFormComponent extends BaseResourceFormComponent<PlanoContratacaoAnual, LoginContabil> {

  datepipe: DatePipe;
  etapa: number = 1;
  unidadeAutoComplete: EddyAutoComplete<Unidade>;
  subElementoAutoComplete: EddyAutoComplete<Despesa>;
  dataInicio: Date;
  dataFim: Date;
  indiceFinanceiro = 0;
  indiceQuantitativo = 0;
  preLista = [];
  totalPCA: number = 0;
  listaSubelemento: { sub: string, total: number }[] = [];
  listaItens: Array<PlanoContratacaoItem> = new Array<PlanoContratacaoItem>();
  itemAtual: PlanoContratacaoItem = null;
  public filtros: FiltroSituacao[] = [
    { label: 'Exibir todos os cadastros', val: 'todos' },
    { label: 'Exibir cadastros revisados', val: 'revisados' },
    { label: 'Exibir todos não revisados', val: 'pendentes' },
  ];
  public filtroSelecionado: FiltroSituacao['val'] = 'todos';
  exibirSoMaterial: boolean = false;
  exibirSoServico: boolean = false;
  subelemento: string = '';
  subelementoList: Array<string> = new Array<string>();
  subelementoComplete = [];
  todos: boolean = false;
  public produtoAutoComplete: EddyAutoComplete<Produto>;
  public produtoUnidadeAutoComplete: EddyAutoComplete<ProdutoUnidade>;
  public produtoUnidade: ProdutoUnidade;
  public planoContratacaoAutoComplete: EddyAutoComplete<PlanoContratacaoAnual>;
  public planoContratacaoImportacao: PlanoContratacaoAnual;

  //Variaveis ajuste rapido
  categoria: number = 0;
  dataDesejada: Date;
  subelementoGeral: Despesa;
  marcarCompleto: boolean = false;
  marcarIncompleto: boolean = false;
  excluirSelecionado: boolean = false;
  seguir: boolean = false;
  editando: boolean = false;
  public erros: string[];
  private indexInicial = 6;

  public paginaCorrente: number = 1;
  public paginaTotal: number;
  public limite: number = 20;
  public listaItensPagina = [];
  public houveAlteracao = false;

  public imaskConfig = {
    mask: Number,
    scale: 2,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  public tiposCatalogo: { id: number, nome: string }[] = [
    { id: 1, nome: 'CNBS' },
    { id: 2, nome: 'Outros' },
  ];

  public ptBR: any;

  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected unidadeService: UnidadeService,
    private despesaService: DespesaService,
    protected service: PlanoContratacaoAnualService,
    protected itensService: PlanoContratacaoAnualItensService,
    protected produtoService: ProdutoService,
    protected produtoUnidadeService: ProdutoUnidadeService,
    private compraItemService: CompraItemService,
    protected exercicioService: ExercicioService,
    private confirmationService: ConfirmationService) {
    super(new PlanoContratacaoAnual(), injector, PlanoContratacaoAnual.converteJson, service);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected async podeAlterar(entidade: PlanoContratacaoAnual): Promise<boolean> {
    return !entidade?.excluido && !entidade?.cadastrado_pncp;
  }

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      orgao: [null, [Validators.required]],
      unidade: [null, [Validators.required]],
      exercicio: [null, [Validators.required]],
      sequencial_pncp: [null],
      cadastrado_pncp: [false],
      itens: [null],
      ignorar_pncp: [false],
      data_pesquida_inicio: [null],
      data_pesquida_fim: [null],
      atualizarPNCP: [false]
    });
  }

  protected parametrosExtras(): {} {
    return {
      relations: 'orgao,unidade,exercicio,itens',
      orderBy: 'itens.numero'
    };
  }

  protected afterInit(): void {
    this.ptBR = this.globalService.obterDataBR();
    this.unidadeAutoComplete = new EddyAutoComplete(this.entidadeForm.get('unidade'), this.unidadeService,
      'id', ['codigo', 'nome'], { ppa_id: this.login.ppa.id, orgao_id: this.login.orgao.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome', 'codigo'] }
    );
    this.datepipe = new DatePipe('pt');
    this.dataInicio = new DateFormatPipe().transform(new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0), []);
    this.dataFim = new DateFormatPipe().transform(new Date(new Date().getFullYear() - 1, 11, 31, 0, 0, 0), []);
    this.carregarAutoCompletes()
    setInterval(() => new GlobalService().calendarMascara(), 500)
  }

  protected beforeSubmit() {
    try {
      if (this.listaItens.length == 0) {
        // throw new Error('É obrigatório o cadastro de pelo menos 1 item.');
        this.entidadeForm.get('itens').setValue([]);
      } else {
        if (this.entidade?.id) {
          this.listaItens = this.listaItens.map((i, index) => {
            return {
              ...i,
              numero: index + 1
            };
          });
        }

        this.entidadeForm.get('itens').setValue(this.listaItens);
      }

      if (this.entidade.id == null) {
        this.entidadeForm.get('data_pesquida_inicio').setValue(this.dataInicio);
        this.entidadeForm.get('data_pesquida_fim').setValue(this.dataFim);
      }

      this.entidadeForm.get('orgao').setValue(this.login.orgao);
      this.entidadeForm.get('exercicio').setValue(this.login.exercicio);
      if (this.entidadeForm.get('id').value) {
        this.entidadeForm.get('atualizarPNCP').setValue(true);
      }
      this.houveAlteracao = false;
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterLoad() {
    if (this.entidade.excluido) {
      this.router.navigate(['/plano-contratacao']);
      toastr.warning('Não é possível editar o PCA. PCA Excluído!');
      return;
    }
    this.listaItensPagina = this.entidade?.itens;
    this.listaItens = this.listaItensPagina;
    this.preencherListaItens();
    this.subelementoList.push('');
    const parametros = { exercicio_id: this.login.exercicio.id, nivel: 6, orderBy: 'codigo', ativo: true }

    this.subElementoAutoComplete = new EddyAutoComplete(null, this.despesaService, 'codigo', ['nome'],
      parametros,
      { number: ['id', 'codigo'], text: ['nome'] },
      async () => {
        if (this.itemAtual != null) {
          this.itemAtual.subelemento = this.subelementoGeral.codigo + ' - ' + this.subelementoGeral.nome;
        }
      }, 10
    );

    if (!this.listaItens) {
      this.listaItens = new Array<PlanoContratacaoItem>();
      this.listaItensPagina = this.listaItens
    } else {
      for (const i of this.listaItens) {
        if (this.subelementoList.indexOf(i.subelemento) == -1) {
          this.subelementoList.push(i.subelemento);
        }

        i['exibir'] = true;
      }
      this.listaItensPagina = this.listaItens

      toastr.success(`Lista do PCA carregada, ${this.listaItens.length} itens sendo exibidos.`)
    }
    if (this.entidade.id) {
      this.etapa = 3;
      this.preencherListaItens();
    }
    this.carregarAutoCompletes();
    this.carregarPlanoContratacaoAutoComplete();
  }

  search(event: any) {
    this.subelementoComplete = this.subelementoList.filter((i) => i.includes(event.query.toUpperCase()));
  }

  async filtrarLista() {
    const copia = [].concat(this.listaItens);
    this.listaItens = [];
    toastr.info('Aguarde, processando lista...');
    await timer(1000).toPromise();
    let qtd = 0;
    for (const i of copia) {
      i['selecionado'] = false;
      i['exibir'] = true;

      if (this.filtroSelecionado === 'pendentes' && !i['pendente']) {
        i['exibir'] = false;
      } else if (this.filtroSelecionado === 'revisados' && i['pendente']) {
        i['exibir'] = false;
      } else if (this.filtroSelecionado === 'todos') {
        i['exibir'] = true;
      }
      if (this.subelemento != null && this.subelemento?.trim().length > 0 && i.subelemento != this.subelemento) {
        i['exibir'] = false;
      }

      if (this.exibirSoMaterial && i.classificacao_catalogo == 2) {
        i['exibir'] = false;
      } else if (this.exibirSoServico && i.classificacao_catalogo == 1) {
        i['exibir'] = false;
      }

      qtd = i['exibir'] ? qtd + 1 : qtd;


      this.listaItens.push(i);
    }
    // this.paginaDigitada(1)
    this.paginaCorrente = 1
    this.preencherListaItens()
    toastr.info(`Filtro aplicado, ${qtd} itens sendo exibidos.`);
  }

  protected afterSubmit(ent: PlanoContratacaoAnual) {
    this.listaItensPagina = ent?.itens;
    this.listaItens = this.listaItensPagina;
    this.entidade.itens = ent?.itens;
    if (this.etapa == 2) {
      this.etapa = 3;
    }
    this.preencherListaItens();
    if (this.houveAlteracao) {
      this.voltar()
    } else {
      this.houveAlteracao = false;
    }
  }

  mudarEtapa(proxima: boolean) {
    if (!proxima) {
      this.etapa--;
      return;
    }

    if (this.etapa == 1 && this.entidadeForm.get('unidade').value == null) {
      toastr.info('Necessário selecionar qual unidade para o PCA.');
      return;
    } else if (this.etapa == 1) {
      this.etapa++;
      return;
    }

    if (this.etapa == 2) {
      this.iniciarPCA();
    }
  }

  carregarPreLista() {
    const param = {
      dtInicial: this.datepipe.transform(this.dataInicio, 'yyyy-MM-dd'),
      dtFinal: this.datepipe.transform(this.dataFim, 'yyyy-MM-dd'),
      orgao_id: this.login.orgao.id,
      indFinanceiro: this.indiceFinanceiro,
      indQuant: this.indiceQuantitativo,
      orderBy: 'p.nome',
      unidade: this.entidadeForm.get('unidade').value.id
    };

    this.compraItemService.planoCompraAnual(param).pipe(takeUntil(this.unsubscribe)).subscribe(lista => {
      this.preLista = lista;

      if (this.preLista.length === 0) {
        toastr.info('Não há resultado para sua pesquisa!');
      } else {
        this.calcularTotaisPlanejamento();
      }
    });
  }

  public calcularTotaisPlanejamento() {
    this.totalPCA = 0;
    this.listaSubelemento = [];

    this.preLista.sort((a, b) => a.subelemento > b.subelemento ? 1 : -1);

    this.funcaoService.agrupar(this.preLista, ['subel_cod_nome'], ['valor_total']).forEach(item => {
      this.listaSubelemento.push({ sub: item.grupo['subel_cod_nome'], total: item.totalizadores['valor_total'] });
    });

    this.totalPCA = this.listaSubelemento.reduce((a, b) => a + b.total, 0);
  }

  public iniciarPCA() {
    let ordemItem: number = 1;
    for (const item of this.preLista) {
      const planoItem = new PlanoContratacaoItem();

      // atributos padrão da entidade
      planoItem.catalogo = 2
      const cod = item.classificacao.split('.');
      planoItem.codigo_item = cod[3];
      planoItem.classificacao_superior = `${cod[0]}.${cod[1]}.${cod[2]}`;
      planoItem.classificacao_superior_nome = this.funcaoService.abreviarStr(item.codigo_produto.split('-').slice(1).join('-').trim(), 254);
      planoItem.descricao = (item.descricao.length > 1000 ? item.descricao.substring(0, 1000) : item.descricao);
      planoItem.subelemento = item.subel_cod_nome;
      planoItem.unidade_fornecimento = item.nome_unidade;
      planoItem.quantidade = item.quantidade_corrigido;
      planoItem.valor_unitario = item.valor_corrigido;
      planoItem.unidade_requisitante = this.entidadeForm.get('unidade').value.nome;

      planoItem.data_desejada = this.buscaDesejadaPadrao();

      planoItem.numero = ordemItem;
      ordemItem++;
      planoItem.categoria_item = item.servico ? 2 : 1;
      planoItem.classificacao_catalogo = item.servico ? 2 : 1;
      planoItem.valor_orcamentario = +(planoItem.quantidade * planoItem.valor_unitario).toFixed(2);

      planoItem['valor_total'] = item.valor_total

      this.listaItens.push(planoItem)
    }

    this.service.filtrar(1, -1, {
      'orgao_id': this.login.orgao.id,
      'exercicio_id': this.login.exercicio.id,
      'unidade_id': this.entidadeForm.get('unidade').value.id
    }).pipe(takeUntil(this.unsubscribe)).subscribe(lista => {
      let pcaComMesmaUnidadeAdministrativa = lista.content

      if (pcaComMesmaUnidadeAdministrativa.length > 0) {
        let pcas = pcaComMesmaUnidadeAdministrativa.map(pca => pca.excluido)
        let todosForamExcluidos = pcas.every(e => e === true);

        if (!todosForamExcluidos) {
          const message = 'Já existe um cadastro não excluído para essa unidade administrativa.'
          this.messageService.add({ severity: 'error', summary: 'PCA duplicado', detail: message });
          throw new Error(message)
        }
      }

      this.submitForm();
    });
  }

  removerPreLista(item, idx) {
    this.preLista.splice(idx, 1)
    toastr.success(`Item ${item.codigo_produto} removido da pre lista!`)
  }

  adicionarItem() {
    this.editando = true;
    this.itemAtual = new PlanoContratacaoItem();
    // this.itemAtual['alterarProduto'] = true;
    this.itemAtual.categoria_item = 1
    this.itemAtual.classificacao_catalogo = 1
    this.itemAtual.data_desejada = this.buscaDesejadaPadrao();

    this.produtoUnidade = null;
    this.produtoUnidadeAutoComplete.id = null;
    this.subelementoGeral = null;
    this.carregarAutoCompletes();
  }

  public async editar(item: PlanoContratacaoItem) {
    this.editando = true;
    item.data_desejada = new DateFormatPipe().transform(
      item?.data_desejada,
      []
    );
    await this.encontraProdutoSelecionado(item)
    this.itemAtual = item
    this.carregarAutoCompletes();
  }

  private async encontraProdutoSelecionado(item: PlanoContratacaoItem): Promise<void> {
    this.produtoUnidade = (await this.produtoUnidadeService.filtrar(1, 1, {
      'produto.nome': item.classificacao_superior_nome, 'produto.orgao.id': this.login.orgao.id,
      relations: 'produto.material.sub_grupo.grupo,produto.aliquota,unidade'
    }).toPromise()).content[0] ?? null;

    if (!this.produtoUnidade) {
      this.produtoUnidade = (await this.produtoUnidadeService.filtrar(1, 1,
        {
          'produto.codigo': item.codigo_item, 'produto.orgao.id': this.login.orgao.id,
          relations: 'produto.material.sub_grupo.grupo,produto.aliquota,unidade'
        }).toPromise()).content[0] ?? null;
    }
    if (this.produtoUnidade?.id) {
      this.produtoUnidadeAutoComplete.id = this.produtoUnidade?.id;
      this.carregaAutoCompleteSubElemento();
    }
  }

  async removerItem(item: PlanoContratacaoItem) {
    this.listaItens = this.listaItens.filter(i => i.numero !== item.numero);

    // this.listaItens = this.listaItens.map((i, index) => {
    //   return {
    //     ...i,
    //     numero: index + 1
    //   };
    // });

    if (item.id) {
      await this.itensService.remover(item.id).toPromise();
      toastr.info('Necessário salvar o PCA para salvar a alteração!', 'Informação');
      toastr.success('Removido com sucesso');
      // await this.submitForm()
    }
    this.preencherListaItens();
  }

  async removerItensSelecionados(itensSelecionados: PlanoContratacaoItem[]) {
    // Remove da lista local
    const idsParaRemover = itensSelecionados
      .filter(i => i.id)
      .map(i => i.id);

    this.listaItens = this.listaItens.filter(i => !i['selecionado']);

    // Remove no backend
    for (const id of idsParaRemover) {
      await this.itensService.remover(id).toPromise();
    }

    this.preencherListaItens();

    toastr.info('Necessário salvar o PCA para persistir a alteração!', 'Informação');
    toastr.success('Itens removidos com sucesso!');
  }



  async salvarItem(completo?: boolean) {
    if (completo != null) {
      this.itemAtual.pendente = completo;
    }
    // if (!this.itemAtual.codigo_item || (this.itemAtual.codigo_item !== '' + this.produtoUnidade && this.produtoUnidade !== null)) {
    //   if (this.produtoUnidade?.produto?.codigo) {
    //     this.itemAtual.codigo_item = '' + this.produtoUnidade.produto.codigo
    //   } else {
    //     this.itemAtual.codigo_item = '' + this.produtoUnidade
    //   }
    // }
    if (!this.itemAtual.id) {
      try {
        this.itemAtual['exibir'] = true;
        if (this.itemAtual.numero) {
          this.listaItens[this.itemAtual.numero - 1] = this.itemAtual;
        } else {
          this.itemAtual.numero = this.itemAtual.numero ? this.itemAtual.numero : this.listaItens.length + 1;
          this.listaItens.push(this.itemAtual);
        }
        // if (this.itemAtual.codigo_item !== this.produtoUnidade?.produto?.codigo && this.produtoUnidade?.id) {
        //   this.itemAtual.codigo_item = '' + this.produtoUnidade?.produto?.codigo
        // }
        if (!this.itemAtual.id) {
          this.itemAtual['exibir'] = true;

          if (!this.itemAtual.numero) {
            let ultimoNumeroInserido = (await this.itensService.filtrar(1, 1, {
              plano_id: this.entidade.id,
              orderBy: 'numero$DESC'
            }).toPromise()).content[0].numero

            this.itemAtual.numero = ultimoNumeroInserido + 1;
          }

          this.itemAtual = await this.itensService.inserir(this.itemAtual).toPromise();

          const existingItemIndex = this.listaItens.findIndex(i => i.numero === this.itemAtual.numero);
          if (existingItemIndex !== -1) {
            this.listaItens[existingItemIndex] = this.itemAtual;
          } else {
            this.listaItens.push(this.itemAtual);
          }
        } else {
          this.itemAtual = await this.itensService.atualizar(this.itemAtual).toPromise();
          this.listaItens = this.listaItens.map(i =>
            i.numero === this.itemAtual.numero ? this.itemAtual : i
          );
        }
        this.itemAtual = null;
        toastr.success('Item salvo com sucesso!');
        await this.submitForm();
        this.houveAlteracao = false;
        this.preencherListaItens();
      } catch (err) {
        this.messageService.add({ severity: 'error', summary: 'Erro ao salvar item', detail: err.error.payload });
      }
    } else {
      try {
        const existingItemIndex = this.listaItens.findIndex(i => i.numero === this.itemAtual.numero);
        if (existingItemIndex !== -1) {
          this.listaItens[existingItemIndex] = this.itemAtual;
        } else {
          this.listaItens.push(this.itemAtual);
        }
        this.itemAtual = await this.itensService.atualizar(this.itemAtual).toPromise();
        this.listaItens = this.listaItens.map(i =>
          i.numero === this.itemAtual.numero ? this.itemAtual : i
        );
        this.itemAtual = null;
        this.listaItensPagina = this.listaItens
        toastr.success('Item salvo com sucesso!');
        this.houveAlteracao = false;
        this.preencherListaItens();
        // await this.submitForm();
      } catch (err) {
        this.messageService.add({ severity: 'error', summary: 'Erro ao salvar item', detail: err.error.payload });
      }
    }
    this.editando = false
  }

  async marcarTodos() {
    if (this.todos) {
      const copia = [].concat(this.listaItens);
      this.listaItens = [];
      toastr.info('Aguarde, processando lista...');
      await timer(1000).toPromise();
      for (const i of copia) {
        if (i['exibir']) {
          i['selecionado'] = true;
          this.listaItens.push(i);
          continue;
        }

        if (this.exibirSoMaterial && i.classificacao_catalogo != 1) {
          i['selecionado'] = false;
          this.listaItens.push(i);
          continue;
        }

        if (this.exibirSoServico && i.classificacao_catalogo != 2) {
          i['selecionado'] = false;
          this.listaItens.push(i);
          continue;
        }

        i['selecionado'] = this.todos;
        this.listaItens.push(i);
      }
    } else {
      await this.desmarcarTudo()
    }
    this.preencherListaItens();
  }

  async efetivar() {

    if (this.excluirSelecionado) {
      const itensParaRemover = this.listaItens.filter(i => i['selecionado']);
      if (itensParaRemover.length) {
        this.confirmarRemocao(null, null, itensParaRemover)
      } else {
        toastr.info('Não há item selecionado para ser removido.')
      }
    } else {

      toastr.info('Aguarde, processando solicitação...');
      await timer(1000).toPromise();
      for (const i of this.listaItens) {
        if (!i['selecionado']) continue;

        if (this.categoria) {
          i.categoria_item = this.categoria;
          i.classificacao_catalogo = this.categoria == 1 ? 1 : 2;
        }

        if (this.dataDesejada) {
          i.data_desejada = this.dataDesejada;
        }

        if (this.marcarCompleto) i.pendente = false;

        if (this.marcarIncompleto) i.pendente = true;


        if (this.subelementoGeral) {
          i.subelemento = this.subelementoGeral.codigo + ' - ' + this.subelementoGeral.nome;
        }

        // this.listaItensPagina = this.listaItens
        this.atualizaIndiceFinanceiroEQuantitativo(i);
      }
      this.houveAlteracao = false;
      await this.submitForm();
      this.preencherListaItens();

      toastr.success('Finalizado!');
    }
  }

  private atualizaIndiceFinanceiroEQuantitativo(item: PlanoContratacaoItem) {
    item.quantidade = item.quantidade * (1 + (this.indiceQuantitativo / 100))
    item.valor_unitario = item.valor_unitario * (1 + (this.indiceQuantitativo / 100))
    item.valor_orcamentario = +(item.quantidade * item.valor_unitario).toFixed(2);
  }

  async desmarcarTudo() {
    const copia = [].concat(this.listaItens);
    this.listaItens = [];
    toastr.info('Aguarde, processando lista...');
    await timer(1000).toPromise();
    for (const i of copia) {
      i['selecionado'] = false;
      this.listaItens.push(i);
    }
  }

  private carregarAutoCompletes() {
    this.produtoUnidadeAutoComplete = new EddyAutoComplete(null, this.produtoUnidadeService, 'produto.codigo', ["produto.codigo", "produto.nome", "unidade.nome"],
      {
        orderBy: "produto.codigo,produto.nome",
        ativo: true,
        'produto.inativo': false,
        'produto.material.servico': this.itemAtual?.classificacao_catalogo == 2 ? true : false,
        'produto.orgao.id': this.login.orgao.id,
        relations: 'produto.aliquota,produto.material.sub_grupo.grupo,unidade'
      },
      { number: ["id", "produto.codigo"], text: ["produto.codigo", "produto.nome", "produto_codigo_comp"] }, async () => {
        this.itemAtual.codigo_item = this.produtoUnidade.produto.codigo;
        this.itemAtual.classificacao_superior_nome = this.produtoUnidade.produto.nome;
        this.itemAtual.classificacao_superior = this.produtoUnidade.produto?.material?.sub_grupo?.grupo?.codigo + '.' + this.produtoUnidade.produto?.material?.sub_grupo?.codigo + '.' + this.produtoUnidade.produto?.material?.codigo;
        this.itemAtual.unidade_fornecimento = this.produtoUnidade.unidade?.nome;
        this.itemAtual.descricao = this.produtoUnidade.produto.descricao;
        this.itemAtual.unidade_requisitante = this.entidade?.unidade?.nome ?? '';
        // this.itemAtual['alterarProduto'] = false;
        this.carregaAutoCompleteSubElemento()
        let subelemento = (await this.despesaService.obter({
          exercicio_id: this.login.exercicio.id,
          nivel: 6,
          ativo: true,
          relations: 'sub_grupos.sub_grupo',
          orderBy: 'codigo',
          'sub_grupos.sub_grupo.id': this.produtoUnidade.produto.material.sub_grupo.id
        }).toPromise());
        if (subelemento?.id)
          this.itemAtual.subelemento = subelemento.codigo + ' - ' + subelemento.nome;
        else this.itemAtual.subelemento = null;
      }//, null,
      // (entidade: ProdutoUnidade) =>
      //   `${entidade['produto.material.sub_grupo.grupo.codigo']}.${entidade['produto.material.sub_grupo.codigo']}.${entidade['produto.material.codigo']}.${entidade['produto.codigo']} - ${entidade['produto.nome']}`
    );
    // this.produtoAutoComplete = new EddyAutoComplete(null, this.produtoService,
    //   'codigo', ['codigo'], { orgao_id: this.login.orgao.id, orderBy: 'codigo,nome', relations: 'material.sub_grupo.grupo,aliquota,unidades.unidade', 'inativo': false, 'unidades.ativo': true, 'material.servico': this.itemAtual?.classificacao_catalogo == 2 }, { text: ['codigo', 'nome', 'unidades.unidade.nome'] }, () => {
    //     this.itemAtual.codigo_item = this.produto.codigo;
    //     this.itemAtual.classificacao_superior_nome = this.produto.nome;
    //     this.itemAtual.classificacao_superior = this.produto?.material?.sub_grupo?.grupo?.codigo + '.' + this.produto?.material?.sub_grupo?.codigo + '.' + this.produto?.material?.codigo;
    //     this.itemAtual.unidade_fornecimento = this.produto?.unidades[0]?.unidade?.nome;
    //     this.itemAtual.descricao = this.produto.descricao;
    //     this.itemAtual.unidade_requisitante = this.entidade?.unidade?.nome ?? '';
    //     // this.itemAtual['alterarProduto'] = false;
    //     this.carregaAutoCompleteSubElemento()
    //   }
    // );
  }

  private carregaAutoCompleteSubElemento() {
    const parametros = {
      exercicio_id: this.login.exercicio.id,
      nivel: 6,
      ativo: true,
      relations: 'sub_grupos.sub_grupo',
      orderBy: 'codigo',
    }

    if (this.produtoUnidade?.produto) {
      parametros['sub_grupos.sub_grupo.id'] = this.produtoUnidade.produto.material.sub_grupo.id;
    }

    this.subElementoAutoComplete = new EddyAutoComplete(null, this.despesaService, 'codigo', ['nome'],
      parametros,
      { number: ['id', 'codigo'], text: ['nome'] },
      async () => {
        if (this.itemAtual != null) {
          this.itemAtual.subelemento = this.subelementoGeral.codigo + ' - ' + this.subelementoGeral.nome;
        }
      }, 10
    );
  }

  public verificarValorOrcamentarioEstimado() {
    if (!this.itemAtual.valor_orcamentario) {
      this.itemAtual.valor_orcamentario = (this.itemAtual?.valor_unitario ?? 0) * (this.itemAtual?.quantidade ?? 0);
    }
  }

  // public alterarCampo() {
  //   this.itemAtual['alterarProduto'] = true;
  // }

  public atualizaValorOrcamentarioTotal() {
    this.itemAtual.valor_orcamentario = (this.itemAtual?.valor_unitario ?? 0) * (this.itemAtual?.quantidade ?? 0)
  }

  public voltar() {
    if (this.itemAtual != null) {
      this.itemAtual = null
      this.editando = false
    } else {
      this.router.navigate(['/plano-contratacao']);
    }
  }

  private buscaDesejadaPadrao(): Date {
    return new Date(this.login.exercicio.ano + 1, 0, 1)
  }

  public cancelaEdicaoItem(item: PlanoContratacaoItem) {
    if (!item.id) {
      this.listaItens.splice(this.listaItens.findIndex(i => i === item), 1);
    }
    this.preencherListaItens();
    this.adicionarItem()
    this.itemAtual = null
    this.editando = false;
  }

  confirmarRemocao(event: Event | null, item?: PlanoContratacaoItem, itens?: PlanoContratacaoItem[]) {
    // Se não houver evento (chamada via efetivar), o target será null
    const target = event ? event.target : (null as any);
    const isMultiplo = itens && itens.length > 0;

    this.confirmationService.confirm({
      target: target,
      message: isMultiplo
        ? `Você está prestes a remover ${itens.length} itens selecionados. Tem certeza?`
        : `O item "${item?.classificacao_superior_nome}" será removido, tem certeza?`,
      header: 'Confirmar Remoção',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: async () => {
        if (isMultiplo) {
          await this.removerItensSelecionados(itens);
        } else if (item) {
          await this.removerItem(item);
        }
        this.houveAlteracao = true;
      },
    });
  }

  validarAlteracaoAoSair() {
    if (this.houveAlteracao) {
      this.confirmationService.confirm({
        message: `Alterações não salvas, deseja salvar antes de sair?`,
        header: 'Aviso',
        icon: 'pi pi-info-circle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        acceptIcon: "none",
        rejectIcon: "none",
        accept: async () => {
          await this.submitForm();
          this.houveAlteracao = true;
        },
      });
    } else {
      this.voltar();
    }
  }

  public proximaPagina() {
    this.paginaCorrente = this.paginaCorrente === this.paginaTotal ? this.paginaTotal : this.paginaCorrente + 1;
    this.preencherListaItens();
    window.scrollTo(0, 0);
  }

  public paginaAnterior() {
    this.paginaCorrente = this.paginaCorrente === 1 ? 1 : this.paginaCorrente - 1;
    this.preencherListaItens();
    window.scrollTo(0, 0);
  }

  public paginaDigitada(pagina: number) {
    this.paginaCorrente = pagina >= this.paginaTotal ? this.paginaTotal : pagina;
    this.preencherListaItens();
    window.scrollTo(0, 0);
  }

  public mudarLimite(limite: number) {
    this.limite = limite;
    this.calcularPaginaTotal();
    this.paginaDigitada(1);
  }

  public preencherListaItens() {
    const inicio = (this.paginaCorrente - 1) * this.limite;
    const fim = inicio + this.limite;
    this.calcularPaginaTotal()
    let lista = this.listaItens.filter(i => i['exibir'])
    this.listaItensPagina = [...lista.slice(inicio, fim)];
  }

  calcularPaginaTotal() {
    let tamanho = this.listaItens.filter(i => i['exibir'])
    this.paginaTotal = Math.ceil(tamanho.length / this.limite);
  }

  public abrirImportacaoOutroPCA() {
    this.planoContratacaoImportacao = null;
    this.carregarPlanoContratacaoAutoComplete();
  }

  private carregarPlanoContratacaoAutoComplete() {
    const parametros = {
      relations: 'orgao,unidade,exercicio,itens',
      orderBy: 'id$DESC',
      'orgao.id': this.login.orgao.id,
      ignoreCondObrig: true,
      excluido: false
    };

    this.planoContratacaoAutoComplete = new EddyAutoComplete(null, this.service, 'id', ['id', 'unidade.nome', 'exercicio.ano'],
      parametros,
      { number: ['id', 'exercicio.ano'], text: ['unidade.nome'] },
      null, null,
      (plano: PlanoContratacaoAnual) => `${plano.id} - ${plano.unidade?.nome ?? ''} - ${plano.exercicio?.ano ? plano.exercicio.ano + 1 : ''}`
    );
  }

  public async importarOutroPCA() {
    if (!this.planoContratacaoImportacao?.id) {
      toastr.warning('Selecione o PCA que deseja importar!');
      return;
    }

    if (this.planoContratacaoImportacao.id === this.entidade?.id) {
      toastr.warning('Selecione um PCA diferente do que está sendo editado!');
      return;
    }

    const planoOrigem = await this.service.obter({
      id: this.planoContratacaoImportacao.id,
      relations: 'orgao,unidade,exercicio,itens',
      orderBy: 'itens.numero'
    }).toPromise();

    if (!planoOrigem?.itens?.length) {
      toastr.info('O PCA selecionado não possui itens para importar.');
      return;
    }

    let itensSomados = 0;
    let itensIncluidos = 0;

    for (const itemOrigem of planoOrigem.itens) {
      const itemExistente = this.listaItens.find(item => this.chaveItemPCA(item) === this.chaveItemPCA(itemOrigem));

      if (itemExistente) {
        itemExistente.quantidade = +(+(itemExistente.quantidade ?? 0) + +(itemOrigem.quantidade ?? 0)).toFixed(4);
        itemExistente.valor_orcamentario = +((itemExistente.quantidade ?? 0) * +(itemExistente.valor_unitario ?? 0)).toFixed(4);
        itemExistente.pendente = true;
        itensSomados++;
      } else {
        this.listaItens.push(this.criarItemImportado(itemOrigem));
        itensIncluidos++;
      }
    }

    this.listaItens = this.listaItens.map((item, index) => ({ ...item, numero: index + 1, plano: null }));
    this.listaItens.forEach(item => item['exibir'] = item['exibir'] ?? true);
    this.entidade.itens = this.listaItens;
    this.houveAlteracao = true;
    this.preencherListaItens();
    $('#dialogImportarOutroPCA').modal('hide');
    toastr.success(`Importação concluída. ${itensIncluidos} item(ns) incluido(s) e ${itensSomados} item(ns) somado(s). Clique em Salvar para persistir.`);
  }

  private chaveItemPCA(item: PlanoContratacaoItem): string {
    return [
      item?.codigo_item,
      item?.classificacao_superior,
      item?.unidade_fornecimento,
      item?.subelemento
    ].map(valor => (valor ?? '').toString().trim().toUpperCase()).join('|');
  }

  private criarItemImportado(itemOrigem: PlanoContratacaoItem): PlanoContratacaoItem {
    const item = Object.assign(new PlanoContratacaoItem(), itemOrigem);
    item.id = null;
    item.numero = this.listaItens.length + 1;
    item.plano = null;
    item.cadastrado_pncp = false;
    item['exibir'] = true;
    item['selecionado'] = false;
    return item;
  }

  public async exportarPCA() {
    if (!this.entidade.id) return;
    toastr.info('Aguarde, exportando PCA...');

    const algCenter: Partial<Alignment> = { vertical: 'middle', horizontal: 'center' };
    const algRight: Partial<Alignment> = { vertical: 'middle', horizontal: 'right' };
    const algLeft: Partial<Alignment> = { vertical: 'middle', horizontal: 'left' };

    const wb = new Workbook();
    wb.creator = this.login.usuario.nome;
    wb.lastModifiedBy = this.login.usuario.nome;
    wb.created = new Date();
    wb.modified = new Date();
    wb.calcProperties.fullCalcOnLoad = true;

    const ws = wb.addWorksheet('Plano de Contratação Anual', { views: [{ state: 'frozen', xSplit: 0, ySplit: 4, activeCell: 'E5' }] });

    ws.columns = [
      { key: 'numero', width: 10, alignment: algCenter, protection: { locked: true } },
      { key: 'nome', width: 100., alignment: algLeft, protection: { locked: true } },
      { key: 'subelemento', width: 70., alignment: algLeft, protection: { locked: true } },
      { key: 'data', width: 20, alignment: algRight, },
      { key: 'quantidade', width: 12, alignment: { vertical: 'middle', horizontal: 'left' } },
      { key: 'valor', width: 16, alignment: algRight },
      { key: 'total', width: 24, alignment: algRight, protection: { locked: true } },
      { key: 'valor_orcado', width: 24, alignment: algRight, protection: { locked: true } },
    ];

    ws.getCell('A1').value = `ARQUIVO DE PREENCHIMENTO PARA PLANO DE CONTRATAÇÃO ANUAL - (${this.login.exercicio.ano + 1})`;
    ws.getCell('A1').alignment = algCenter;
    ws.getCell('A1').font = { bold: true, size: 16 };
    ws.getCell('A1').protection = { locked: true };
    ws.mergeCells('A1:H1');

    ws.getCell('A2').value = 'ID:' + this.entidade.id;
    ws.getCell('A2').alignment = algCenter;
    ws.getCell('A2').protection = { locked: true };

    ws.getCell('B2').value = this.login.orgao.nome + ' - ' + this.login.cidade.nome;
    ws.getCell('B2').alignment = algCenter;
    ws.getCell('B2').font = { bold: true, size: 12 };
    ws.getCell('B2').protection = { locked: true };
    ws.mergeCells('B2:H2');

    ws.getCell('A3').value = this.entidade.unidade.codigo + ' - ' + this.entidade.unidade.nome;
    ws.getCell('A3').alignment = algCenter;
    ws.getCell('A3').font = { bold: true, size: 12 };
    ws.getCell('A3').protection = { locked: true };
    ws.mergeCells('A3:H3');

    ws.getCell('A4').value = '';
    ws.getCell('A4').alignment = algCenter;
    ws.getCell('A4').font = { bold: true, size: 16 };
    ws.getCell('A4').protection = { locked: true };
    ws.mergeCells('A4:H4');

    ws.getRow(5).values = ['Número', 'Nome', 'Subelemento', 'Data Desejada', 'Quantidade', 'Valor Unit.', 'Total', 'Valor Orç. Estimado'];
    ws.getRow(5).alignment = algCenter;
    ws.getRow(5).font = { bold: true };
    ws.getRow(5).protection = { locked: true };

    ws.getColumn(9).hidden = true;

    let linha = 6;
    this.entidade.itens.forEach((item) => {
      ws.getRow(linha);

      ws.getCell(`A${linha}`).value = item.numero;
      ws.getCell(`A${linha}`).alignment = algCenter;
      ws.getCell(`A${linha}`).protection = { locked: true };

      ws.getCell(`B${linha}`).value = item.codigo_item + ' - ' + item.classificacao_superior_nome + ' - ' + item.unidade_fornecimento;
      ws.getCell(`B${linha}`).alignment = algLeft;
      ws.getCell(`B${linha}`).protection = { locked: true };

      ws.getCell(`C${linha}`).value = item.subelemento;
      ws.getCell(`C${linha}`).alignment = algLeft;
      ws.getCell(`C${linha}`).protection = { locked: true };

      ws.getCell(`D${linha}`).value = new Date(item.data_desejada);
      ws.getCell(`D${linha}`).protection = { locked: false };
      ws.getCell(`D${linha}`).alignment = algCenter;
      ws.getCell(`D${linha}`).numFmt = 'dd/mm/yyyy';
      ws.getCell(`D${linha}`).dataValidation = {
        type: 'custom',
        operator: 'lessThanOrEqual',
        allowBlank: true,
        showInputMessage: true,
        formulae: [0],
        promptTitle: 'Data Desejada Inválida!',
        prompt: 'A Data informada deve ser no formato dd/mm/yyyy'
      };

      ws.getCell(`E${linha}`).value = parseFloat(item.quantidade.toString()).toFixed(2).replace('.', ',');
      ws.getCell(`E${linha}`).alignment = algCenter;
      ws.getCell(`E${linha}`).protection = { locked: false };
      ws.getCell(`E${linha}`).numFmt = '#,##0.00;[Red]\-#,##0.00';
      ws.getCell(`E${linha}`).dataValidation = {
        type: 'decimal',
        operator: 'lessThanOrEqual',
        allowBlank: true,
        showInputMessage: true,
        formulae: [0],
        promptTitle: 'Quantidade Inválida!',
        prompt: 'A quantidade informada deve ser positivo'
      };

      ws.getCell(`F${linha}`).value = parseFloat(item.valor_unitario.toString()).toFixed(4).replace('.', ',')
      ws.getCell(`F${linha}`).alignment = algRight;
      ws.getCell(`F${linha}`).numFmt = '#,##0.0000;[Red]\-#,##0.0000';
      ws.getCell(`F${linha}`).protection = { locked: false };
      ws.getCell(`F${linha}`).dataValidation = {
        type: 'decimal',
        operator: 'lessThanOrEqual',
        allowBlank: true,
        showInputMessage: true,
        formulae: [0],
        promptTitle: 'Valor Inválido!',
        prompt: 'O valor informado deve ser positivo'
      };

      ws.getCell(`G${linha}`).value = { formula: `(E${linha} * F${linha})`, date1904: null };
      ws.getCell(`G${linha}`).alignment = algRight;
      ws.getCell(`G${linha}`).numFmt = '#,##0.00;[Red]\-#,##0.00';
      ws.getCell(`G${linha}`).protection = { locked: true };

      // ws.getCell(`H${linha}`).value = parseFloat((+item.valor_orcamentario !== +item.valor_unitario * +item.quantidade ? item.valor_orcamentario : +item.valor_unitario * +item.quantidade).toString()).toFixed(4).replace('.', ',');
      ws.getCell(`H${linha}`).value = { formula: `(E${linha} * F${linha})`, date1904: null };
      ws.getCell(`H${linha}`).alignment = algRight;
      ws.getCell(`H${linha}`).numFmt = '#,##0.0000;[Red]\-#,##0.0000';
      ws.getCell(`H${linha}`).protection = { locked: true };

      ws.getCell(`I${linha}`).value = item.id;
      ws.getCell(`I${linha}`).alignment = algCenter;
      ws.getCell(`I${linha}`).protection = { locked: true };

      linha++;
    });

    await ws.protect('842d51933523ffbcdd1836e7d4a9323ff8b9cdd183', {});

    wb.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = `Plano de Contratação Anual - (${this.entidade.exercicio.ano + 1}).xlsx`;
      link.target = '_blank';
      link.click();
      window.URL.revokeObjectURL(downloadURL);
    });

    toastr.success('Concluído com sucesso a exportação do PCA...');
  }

  public async importarPCA(event: any, fileUpload: any) {
    if (!event.files || event.files.length === 0) {
      toastr.warning('Nenhum arquivo selecionado!')
      return;
    }

    try {
      // variavel para guardar informacoes do mapa de precos
      const regXlsx: { id: number, numero: number, data_desejada: string, quantidade: string, valor: string, valor_orcamentario: string }[] = [];
      this.erros = [];

      // le mapa de preços enviado (xlsx)
      const file: File = event.files[0];
      const wb = new Workbook();
      await wb.xlsx.load(await file.arrayBuffer());
      if (!wb.getWorksheet('Plano de Contratação Anual')) {
        this.erros.push(`Arquivo inválido, verifique se o arquivo pertence a outra finalidade`);
        return;
      }
      const ws: Worksheet = wb.getWorksheet('Plano de Contratação Anual');

      const cellValue = ws.getCell('A2').value;
      const idXlsx = typeof cellValue === 'string' ? +cellValue.match(/ID:\s*(\d+)/)[1] : undefined;

      if (!idXlsx || idXlsx !== this.entidade.id) {
        this.erros.push(`Código inválido no arquivo de preenchimento do PCA, verifique se o arquivo pertence a outro PCA`);
      } else {
        for (let linha = this.indexInicial; linha < this.listaItens.length + this.indexInicial; linha++) {
          const item: PlanoContratacaoItem = this.listaItens[linha - this.indexInicial];
          const itemXlsx = {
            id: +ws.getCell(`I${linha}`).value?.toString(),
            numero: +ws.getCell(`A${linha}`).value.toString(),
            data_desejada: ws.getCell(`D${linha}`).value.toString(),
            quantidade: ws.getCell(`E${linha}`).value.toString(),
            valor: ws.getCell(`F${linha}`).value?.toString(),
            valor_orcamentario: (+ws.getCell(`E${linha}`).value?.toString()?.replace(',', '.') * +ws.getCell(`F${linha}`).value?.toString()?.replace(',', '.'))?.toFixed(4)?.toString()?.replace('.', ','),
          };

          if (item.id !== itemXlsx.id) {
            this.erros.push(`Célula A${linha} com valor inválido (esperado ${item.numero})`);
          }
          if (+itemXlsx.valor < 0) {
            this.erros.push(`Célula F${linha} com valor inválido (esperado valor positivo)`);
          }
          if (!itemXlsx.valor_orcamentario) {
            this.erros.push(`Célula H${linha} com valor inválido (esperado valor preenchido)`);
          }
          const date = new Date(itemXlsx.data_desejada);
          if (isNaN(date.getTime()) || !itemXlsx?.data_desejada) {
            this.erros.push(`Célula D${linha} com data inválida`);
          }
          // itemXlsx.valor_orcamentario = Number(itemXlsx.quantidade.replace(',', '.')) * Number(itemXlsx.valor.replace(',', '.'))

          regXlsx.push(itemXlsx);
        }

        if (!regXlsx.find(x => (Number(x.valor_orcamentario?.replace(',', '.')) > 0) || Number(x.valor.replace(',', '.')) > 0)) {
          this.erros.push(`Nenhum item foi cotado no arquivo informado!`);
        }
      }

      if (this.erros.length > 0) {
        throw new Error(`${this.erros.length} erro(s) encontrado(s) no preenchimento do PCA, verifique o conteúdo do arquivo e importe novamente!`);
      }

      for (let i = 0; i < this.entidade.itens.length; i++) {
        const item = this.entidade.itens[i];
        const itemXlsx = regXlsx[i];

        if (item.id !== itemXlsx.id) {
          throw new Error(`Ordem inválida para o item ${item.numero}, valor preenchido é ${itemXlsx.numero}`)
        }

        item.quantidade = +itemXlsx.quantidade.replace(',', '.');
        item.valor_unitario = +itemXlsx.valor.replace(',', '.');
        item.valor_orcamentario = +itemXlsx.valor_orcamentario.replace(',', '.');
        item.data_desejada = new Date(itemXlsx.data_desejada);
      }

      this.preencherListaItens();

      toastr.success('PCA importado com sucesso!');
      $('#dialogImportarPCA').modal('hide');
      this.submitForm()
    } catch (ex) {
      toastr.error(ex.message ? ex.message : ex);
    } finally {
      fileUpload.clear();
    }
  }

  public fecharImportar() {
    this.erros = [];
    $('#dialogImportarPCA').modal('hide');
  }
}
